module.exports = __webpack_public_path__ + "static/media/Fluency Heuristic.682a3a01.jpg";